export default __webpack_public_path__ + "static/media/img1.ddc1aa76.jpg";